// carousels.js — Swiper presets keyed on data-carousel; loaded after swiper-bundle.
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

const CAROUSEL_PRESETS = {
  cards: (el) => {
    const desktop = Number(el.dataset.slides) || 3;
    const tablet = Number(el.dataset.slidesTablet) || desktop;
    const mobile = Number(el.dataset.slidesMobile) || 1;
    return {
      slidesPerView: mobile,
      spaceBetween: 10,
      centeredSlides: mobile > 1,
      grabCursor: true,
      keyboard: { enabled: true },
      scrollbar: {
        el: el.querySelector('.swiper-scrollbar'),
        draggable: true,
        dragSize: 'auto',
      },
      navigation: {
        nextEl: el.querySelector('.carousel-next'),
        prevEl: el.querySelector('.carousel-prev'),
      },
      breakpoints: {
        640: {
          slidesPerView: Math.min(2, tablet),
          spaceBetween: 15,
          centeredSlides: mobile > 1,
        },
        768: { slidesPerView: tablet, spaceBetween: 20, centeredSlides: false },
        1024: {
          slidesPerView: desktop,
          spaceBetween: 30,
          centeredSlides: false,
        },
      },
    };
  },
  autoplay: (el) => ({
    slidesPerView: 1,
    loop: true,
    grabCursor: true,
    keyboard: { enabled: true },
    effect: el.dataset.effect || 'slide',
    // enabled:false (not autoplay:false) keeps the delay if a visitor opts in via the pause button.
    autoplay: {
      enabled: !reducedMotion,
      delay: Number(el.dataset.delay) || 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
  }),
};

// aria-pressed="true" means paused; the label stays "Pause autoplay".
const bindPause = (el, swiper) => {
  const btn = el.querySelector('[data-carousel-pause]');
  if (!btn || !swiper.autoplay) return;
  btn.setAttribute('aria-pressed', String(!swiper.autoplay.running));
  btn.addEventListener('click', () => {
    const running = swiper.autoplay.running;
    running ? swiper.autoplay.stop() : swiper.autoplay.start();
    btn.setAttribute('aria-pressed', String(running));
  });
};

const initCarousels = (root = document) => {
  if (typeof Swiper === 'undefined') {
    if (isDev) console.warn('Swiper unavailable; carousels not initialised');
    return;
  }
  root
    .querySelectorAll('[data-carousel]:not([data-carousel-ready])')
    .forEach((el) => {
      // Hidden roots (e.g. a closed accordion panel) would init at zero width; left unmarked so a later initCarousels(panel) picks them up.
      if (!el.getClientRects().length) return;
      const preset = CAROUSEL_PRESETS[el.dataset.carousel];
      if (!preset) {
        if (isDev)
          console.warn('Unknown carousel preset', el.dataset.carousel, el);
        return;
      }
      el.dataset.carouselReady = 'true';
      bindPause(el, new Swiper(el, preset(el)));
    });
};

window.initCarousels = initCarousels;
document.addEventListener('DOMContentLoaded', () => initCarousels());
